export const LOADER_STATUSS         =   'LOADER_STATUSS';
export const LOADER_STATUS          =   'LOADER_STATUS';
export const SAVE_LOADER_STATUS     =   'SAVE_LOADER_STATUS';
export const GET_STATUSS            =   'GET_STATUSS';
export const GET_STATUS             =   'GET_STATUS';
export const FAILD_STATUSS          =   'FAILD_STATUSS';
export const FAILD_STATUS           =   'FAILD_STATUS';
export const FORM_STATUS_FAILD      =   'FORM_STATUS_FAILD';